import React, { forwardRef, FunctionComponent } from "react";
import Box, { BoxProps } from "../box/Box";

export type FlexColumnProps = Omit<BoxProps, "display" | "flexDirection" | "height">;

export const FlexColumn: FunctionComponent<FlexColumnProps> = forwardRef((props, ref) => {
	const { flexGrow, ...otherProps } = props;

	return (
		<Box
			display="flex"
			flexDirection="column"
			flexGrow={flexGrow}
			height={flexGrow == null ? 1 : "auto"}
			{...{ ref }}
			{...otherProps}
		/>
	);
});

export default FlexColumn;